import React, { useState } from "react";
import axios from "axios";

import "./ContactFormStyles.css";

function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { name, email, phone, subject, message };
    axios
      .post("/send", data)
      .then((res) => {
        console.log(res);
        setSuccessMessage("Your message has been sent!");
        setErrorMessage("");
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(
          "There was an error sending your message. Please try again later."
        );
        setSuccessMessage("");
      });
  };

  return (
    <div className="form-container">
      <div className="contact-info">
        <h1>Contact Me</h1>
        <p>Name: Luis Marquez</p>
        <p>Email: mrqz83@hotmail.com</p>
        <p>Phone: (289) 5478671</p>
        <br />
        <iframe
          title="Niagara Falls Map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d452662.1520140044!2d-79.1293776381286!3d43.07470621527445!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM0vCsDQ3JzUyLjIiTiA3OcKwMTYnMzMuNiJF!5e0!3m2!1sen!2sus!4v1648221655508!5m2!1sen!2sus"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      <div className="form-container">
        <h1>Send me a message!</h1>
        <br />
        <form onSubmit={handleSubmit}>
          <input
            placeholder="Name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            placeholder="Email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            placeholder="Phone"
            name="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <input
            placeholder="Subject"
            name="subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <textarea
            placeholder="Message"
            rows="6"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button>Send Message</button>
        </form>
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    </div>
  );
}

export default ContactForm;
